import React, {  useState } from 'react';
import InputForm from '../../../InputT';
import { useTranslation } from 'react-i18next';
import DataType from '../../../../Types/DataTablePiclist';
import { Box } from '@mui/material';
import { useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import DataSelect from '../../../../Types/DataSelect';
import SelectOption from '../../../SelectOption';


const Tab1 = (props: { etatG?: boolean, form?: any, Function?: Function }) => {
  const datas: DataType[] = [];
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const [Libelle, setLibelle] = useState<JSX.Element>
    (
      <>
        <InputForm type='TextArea' width={6} label='libelle Interet commission Taxe' name='LibIndebTax' />
      </>
    );


  const HandlerChangeOption = () => {
    let res: string = props.form.getFieldValue("OptionImput");
    let Labelle1: string = "Libelle Interet commission Taxe";
    let Labelle2: string = "";
    switch (res) {
      case '1':
        {
          props.form.setFieldValue("LibIndebTax",'');
          setLibelle(
            <>
              <InputForm type='TextArea' width={6} label={Labelle1} name='LibIndebTax' />
            </>
          )
          break;
        }
      case '2':
        {
          Labelle1 = "Interet Commission";
          Labelle2 = "Libelle Taxte";
          setLibelle(
            <>
              <InputForm type='TextArea' width={6} label={Labelle1} name='LibIndebTax' />
              <InputForm type='TextArea' width={6} label={Labelle2} name='LibTax' />
            </>
          )
          break;
        }
      case '3':
        {
          Labelle1 = "Interet et Taxe"
          props.form.setFieldValue("LibIndebTax",'');
          setLibelle(
            <>
              <InputForm type='TextArea' width={6} label={Labelle1} name='LibIndebTax' />
            </>
          )
          break;
        }
      case '4':
        {
          Labelle1 = "Libelle Interet";
          Labelle2 = "Libelle Taxe";
          setLibelle(
            <>
              <InputForm type='TextArea' width={6} label={Labelle1} name='LibIndebTax' />
              <InputForm type='TextArea' width={6} label={Labelle2} name='LibTax' />
            </>
          )
          break;
        }
      case '5':
        {
          Labelle1 = "Libelle Commission et Taxe"
    
          props.form.setFieldValue("LibIndebTax",'');
          setLibelle(
            <>
              <InputForm type='TextArea' width={6} label={Labelle1} name='LibIndebTax' />
            </>)
          break;
        }
      case '6':
        {
          Labelle1 = "Libelle Commission";
          Labelle2 = "Libelle Taxe";
          setLibelle(
            <>
              <InputForm type='TextArea' width={6} label={Labelle1} name='LibIndebTax' />
              <InputForm type='TextArea' width={6} label={Labelle2} name='LibTax' />
            </>)

          break;
        }
    }
  }


  const dataTypeImputation: DataSelect[] = [
    { label: "1--intérêt Débiteur et Commission", value: "1" },
    { label: "2--intérêt Créditeur", value: "2" },
  ]

  const dataTypeOption: DataSelect[] = [
    { label: "1--Intérêt Débiteur + Commission + Taxe", value: "1" },
    { label: "2--Intérêt Débiteur + Commission et Taxe ", value: "2" },
    { label: "3--Intérêt Débiteur + Taxe ", value: "3" },
    { label: "4--Intérêt Débiteur et Taxe ", value: "4" },
    { label: "5--Commission  + Taxe ", value: "5" },
    { label: "6--Commission  et Taxe ", value: "6" },
  ]


  return (
    <div className='tabItem' >
      <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
        <Box className='bordure1'>
          <SelectOption Size={'midler'} width={4} DefaulValue={'1'} Option={dataTypeImputation} label="Type D'imputation" name='TypeImputation' />
        </Box>
        {props.form.getFieldValue('TypeImputation') === '1' ?
          <>
            <Box className='bordure1'>
              <SelectOption Size={'midler'} width={4} DefaulValue={'1'} Option={dataTypeOption} onchange={HandlerChangeOption} label="Option D'imputation" name='OptionImput' />
            </Box>
            <Box className='bordure1' style={{ display: 'flex', gap: '1em' }} >
              <Box width={'100%'}>
                {Libelle}
              </Box>
            </Box>
          </>
          :
          <>
            <Box className='bordure1' >
              <InputForm type='TextArea' label='libelle Intéret créditeur'  name='libgcptINTTaxC' />
            </Box>
          </>
        }
      </Box>
    </div>
  );
}

export default Tab1;